import { type ReservationType } from 'types/v1/reservation'

export function getReservationDateProps(reservation: ReservationType) {
  return {
    dateText: reservation.reserved_date_text,
  }
}

export function getReservationDatePropsForChange(
  reservation: ReservationType,
  unapprovedReservation: ReservationType,
) {
  return {
    prevDateText:
      reservation.reserved_date_text !==
      unapprovedReservation.reserved_date_text
        ? reservation.reserved_date_text
        : undefined,
    dateText: unapprovedReservation.reserved_date_text,
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationDate/presenter.js